import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import throttle from 'lodash/throttle';

import configureStore from './store/configureStore';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { saveState } from './store/localStorage';

const store = configureStore();

store.subscribe(throttle(() => {
    saveState(store.getState());
}, 1000));

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js